import { Component, ViewChild, EventEmitter, AfterViewInit } from '@angular/core'
import { DialogComponent, DialogConfiguration, IDialogButton } from '@mprep/shared/angular'

@Component({
  selector: 'mp-sequenced-dialog',
  template: '<mp-dialog #dialog></mp-dialog>'
})
export class SequencedDialogComponent implements AfterViewInit {

  public onContinue: EventEmitter<boolean> = new EventEmitter<boolean>()

  private _sequence: DialogConfiguration[]
  private _currentPosition: number = 0

  @ViewChild('dialog')
  private _dialog: DialogComponent

  public ngAfterViewInit() {
    this.onContinue.subscribe(() => {
      this._setNextConfiguration()
    })
  }

  public setSequence(sequence: DialogConfiguration[]) {
    if (! this._sequence) {
      this._sequence = sequence.map((config, index) => {
        config['buttons'] = config['buttons'] || []

        if (index !== this._lastSequence(sequence)) {
          config['buttons'] = [this._getContinueButton(config)]
        }

        return config
      })
      this._setNextConfiguration()
    }
  }

  public open() {
    this._reset()
    this._dialog.open()
  }

  private _reset() {
    this._currentPosition = 0
    this._setNextConfiguration()
  }

  private _lastSequence(sequence) {
    return sequence.length - 1
  }

  private _setNextConfiguration() {
    this._dialog.configure(this._getCurrentConfiguration())
    this._currentPosition = (this._currentPosition + 1) % this._sequence.length
  }

  private _getCurrentConfiguration(): DialogConfiguration {
    return this._sequence[this._currentPosition]
  }

  private _getContinueButton(dialogConfig: DialogConfiguration): IDialogButton {
    const button = { title: 'Continue', emitter: this.onContinue }

    return Object.assign(button, dialogConfig.buttons[0])
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/sequenced-dialog/sequenced-dialog.component.ts